import styled from 'styled-components'
import { colors } from '../../../lib/colors'
import { BUTTON_STYLED_PROPS } from './interface'
import { animations } from '../../../animations/animations'

const { flickle } = animations()

export const PositionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 22px;
`

export const PositionsContainer = styled.div<BUTTON_STYLED_PROPS>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3px 3px 0 3px;
  cursor: pointer;
  span {
    font-size: 10px;
    color: ${({ active, withBet }) =>
      active || withBet ? colors.secondary : colors.quaternary};
    transition: color 500ms linear;
  }
  pointer-events: ${({ disabled }) => (disabled ? 'none' : '')};
`
export const Position = styled.div<BUTTON_STYLED_PROPS>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  margin-bottom: 6px;
  background: ${({ active, withBet }) =>
    withBet
      ? colors.secondary
      : active
      ? colors.primaryDark
      : colors.primaryLight};
  border: ${({ active, withBet }) =>
    !withBet && active ? `2px solid ${colors.secondary}` : ''};
  transition: all 200ms linear;
  ${({ active, disabled }) => active && !disabled && flickle};
`
export const Content = styled.div<BUTTON_STYLED_PROPS>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: ${({ active, withBet }) =>
    withBet
      ? `2.5px solid ${colors.primaryDark}`
      : active
      ? `2.5px solid ${colors.primaryDark}`
      : `2.5px solid ${colors.primaryLight}`};

  background: ${({ active, withBet }) =>
    withBet ? colors.secondary : active ? colors.primaryDark : ''};
  color: ${({ active, withBet }) =>
    withBet
      ? colors.tertiary
      : !withBet && active
      ? colors.secondary
      : colors.tertiary};
  font-size: 10px;
  transition: all 200ms linear;

  path {
    fill: ${({ active, withBet }) =>
      active && !withBet ? colors.secondary : colors.tertiary};
    stroke: ${({ active, withBet }) =>
      active && !withBet ? colors.secondary : colors.tertiary};
  }
`
export const BetReplyFooter = styled.div`
  margin-bottom: 47px;
`

export const Bet = styled.div`
  display: flex;
  margin-top: 6px;
  span {
    color: ${colors.secondary};
    font-size: 10px;
  }
`
